const getFallbackFontStyles = (langs, fontfamily) => {
  let template = '';
  langs.map(lang => {
    template += `html[lang=${lang}] { font-family: ${fontfamily}}`;
  });

  return template;
};

export default getFallbackFontStyles;
